// extracted by mini-css-extract-plugin
export var bodySections = "_bq-8";
export var gray = "_bq-7";
export var green = "_bq-4";
export var iconContainer = "_bq-9";
export var iconWidgetContainer = "_bq-1";
export var phoneIcon = "_bq-2";
export var red = "_bq-5";
export var statusDot = "_bq-3";
export var widgetContainer = "_bq-0";
export var yellow = "_bq-6";